import { Div, FormBuilder, H2, Label, Loader, Touchable } from "@grassrootly/rn-core";
import { ScreenLayout } from "../../layout/components";
import { forgotPasswordForm } from "./ForgotPassword.types";
import { useForgotPassword } from "./useForgotPassword";
import { RootStackScreenProps } from "../../navigation/Navigation.types";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { Platform } from "react-native";
import { Logo } from "../../layout/components/logo";

export default function ForgotPasswordScreen({}: RootStackScreenProps<"forgot-password">) {
  const { onSubmit, reseting, goBack } = useForgotPassword();
  const insents = useSafeAreaInsets();
  return (
    <Div
      classNames={[
        "flex1",
        "bgNeutralDarkerDark",
        "bwTop-{1}",
        "borderPrimary",
        "p16",
        `pb-{${insents.bottom + 16 + (Platform.OS == "web" ? 16 : 0)}}`,
        "h100",
      ]}
    >
      <Div classNames={["flex1", "maxW-{920}", "w-{100%}", "mr-{auto}", "ml-{auto}"]}>
        <Touchable classNames={["ml-{auto}"]} onPress={goBack}>
          <Label type="l2Regular" classNames={["colorPrimaryMain"]}>
            Close
          </Label>
        </Touchable>
        <Div classNames={["flex1", "alignItemsCenter", Platform.OS === "web" ? "mt-{56}" : "justifyContentCenter"]}>
          <Logo />
          <H2 classNames={["h4", "mb-{24}", "mt-{16}"]}>Forgot Password</H2>
          <Div classNames={["w-{100%}", "maxW-{300}"]}>
            <Label classNames={["l2Regular", "mb-{24}"]}>
              The password recovery link will be sent to your email address.
            </Label>
            <FormBuilder
              form={forgotPasswordForm}
              onSubmit={onSubmit}
              isSubmitting={reseting}
              submitFormOnEnter={true}
              resetFormOnSubmit
            />
          </Div>
        </Div>
      </Div>
    </Div>
  );
}
